<template>
  <div
    class="flex flex-col xl:flex-row xl:justify-evenly justify-center items-center my-8 gap-4"
  >
    <ReactiveCard
      v-for="step in steps"
      :key="step.number"
      class="w-[400px] xl:min-w-[280px] xl:w-[280px]"
    >
      <div class="flex items-center space-x-2 h-[280px]">
        <div class="h-full">
          <div class="font-bold text-[3rem] h-fit px-2 bg-slate-500 rounded">
            {{ step.number }}
          </div>
        </div>
        <div>
          <div class="font-semibold text-2xl mb-2">
            {{ step.title }}
          </div>
          {{ step.description }}
        </div>
      </div>
    </ReactiveCard>
  </div>
</template>

<script setup>
import ReactiveCard from "@/components/ReactiveCard.vue";

const steps = [
  {
    number: 1,
    title: "Create Reviews",
    description:
      "Create custom review templates through our ReviewIQ platform. Optionally attach an invoice and pick key behavior responses.",
  },
  {
    number: 2,
    title: "Analyze Client Behavior",
    description:
      " Track your clients' reviews and invoice payments with powerful charts and insightful metrics.",
  },
  {
    number: 3,
    title: "Increase Client Retention",
    description:
      "Leverage your new review results and behavior data to offer innovative data-driven services.",
  },
];
</script>
<style scoped></style>
